<template>
  <div class="h-11.5 relative top-nav-bar-placeholder">
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="handleClickLeft"
      class="h-11.5"
      safe-area-inset-top
      fixed
    >
      <template #right>
        <slot name="right"></slot>
      </template>
    </van-nav-bar>
  </div>
</template>
<script setup lang="ts">
import { useGoBack } from '@/composables/useGoBack'
const { goBack } = useGoBack()

const props = defineProps<{ title: string; onClickLeft?: () => void }>()
const handleClickLeft = () => {
  if (props.onClickLeft) {
    props.onClickLeft()
  } else {
    goBack()
  }
}
</script>
<style scoped>
.top-nav-bar-placeholder :deep(.van-nav-bar__content) {
  height: 46px;
}
.top-nav-bar-placeholder :deep(.van-icon) {
  color: #262626;
  font-weight: 700;
  font-size: 16px;
}
</style>
